import type { HttpGet } from '@/shared/infra/http'
import type { ListEventOptions } from '@/shared/domain/use-cases'
import type { EventOption } from '@/shared/domain'
import { formatDate } from '@/shared/infra/format'

function formatScheduleDate(value: string): string {
  return formatDate(value) || value
}

function fallbackName(type: unknown, date: string): string {
  const label =
    typeof type === 'string' && type.length > 0
      ? type.charAt(0).toUpperCase() + type.slice(1)
      : 'Event'
  return `${label} · ${formatScheduleDate(date)}`
}

export class EdgeListEventOptionsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListEventOptions = async (params) => {
    const query = new URLSearchParams()
    query.set('orgId', params.orgId)
    query.set('orgType', params.orgType)
    query.set('type', 'event')

    const result = await this.http.get<{ entries: Record<string, unknown>[] }>({
      url: `/scheduling?${query.toString()}`,
    })

    return result.entries.reduce<EventOption[]>((options, entry) => {
      const id = entry.id
      const date = entry.scheduleDate
      if (typeof id === 'string' && typeof date === 'string') {
        const rawName = entry.name
        const name =
          typeof rawName === 'string' && rawName.trim().length > 0
            ? rawName
            : fallbackName(entry.type, date)
        options.push({ id, name, date })
      }
      return options
    }, [])
  }
}
